import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useOverflowDetector, DirectionEnum } from "@perxis-auto/shared";
import DealerDetails from "../DealerDetails/DealerDetails.js";
import Col from "../Grid/Col.js";
import classnames from "../../utils/classnames.js";
import Row from "../Grid/Row.js";
import './DealersList.css';import '../Grid/Grid.css';/* empty css                */
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import "antd/es/config-provider";
import "style-inject";
import { useProviderContext } from "../Provider/context.js";
/* empty css                 */
const DealersListItem = ({
  id,
  title,
  address,
  brand,
  description,
  onSelect,
  onMouseIn,
  onMouseOut,
  phone,
  tags,
  isHovered,
  className,
  ...props
}) => {
  const { ref: tagsRef, overflow: tagsOverflow } = useOverflowDetector();
  const { direction } = useProviderContext();
  const isRTL = direction === DirectionEnum.Rtl;
  const directionalIcon = React.useMemo(
    () => /* @__PURE__ */ jsx(Icon, { name: isRTL ? "back" : "forward", className: classnames("perxis-auto-dealers-list-item__forward") }),
    [isRTL]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      tabIndex: 0,
      role: "button",
      onKeyUp: () => onSelect(id),
      onMouseEnter: (e) => onMouseIn(e, id),
      onMouseLeave: (e) => onMouseOut(e, id),
      onClick: () => onSelect(id),
      className: classnames(
        [
          "perxis-auto-dealers-list-item",
          {
            "perxis-auto-dealers-list-item--rtl": isRTL,
            "perxis-auto-dealers-list-item--hovered": isHovered
          }
        ],
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-blue"], children: [
        /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
          /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Paragraph, { level: "main", color: "darkest", className: classnames("perxis-auto-dealers-list-item__title"), children: title }) }),
          !!brand && /* @__PURE__ */ jsx(Col, { span: 24, children: brand.image ? /* @__PURE__ */ jsx(
            "img",
            {
              src: brand.image,
              alt: brand.name,
              className: classnames("perxis-auto-dealers-list-item__brand-image")
            }
          ) : /* @__PURE__ */ jsx(
            Typography.Paragraph,
            {
              level: "main",
              color: "darkest",
              className: classnames("perxis-auto-dealers-list-item__brand-name"),
              children: brand.name
            }
          ) }),
          /* @__PURE__ */ jsxs(Col, { span: 24, children: [
            /* @__PURE__ */ jsx(
              Typography.Paragraph,
              {
                level: "small",
                color: "dark-light",
                className: classnames("perxis-auto-dealers-list-item__address"),
                children: address
              }
            ),
            !!description && /* @__PURE__ */ jsx(
              Typography.Paragraph,
              {
                level: "small",
                color: "dark",
                className: classnames("perxis-auto-dealers-list-item__description"),
                children: description
              }
            ),
            !!phone && /* @__PURE__ */ jsx(
              Typography.Paragraph,
              {
                level: "small",
                color: "dark",
                "data-phone": phone,
                className: classnames("perxis-auto-dealers-list-item__phone"),
                children: phone
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { wrap: false, justify: tags.length > 0 ? "space-between" : "end", children: [
          tags.length > 0 && /* @__PURE__ */ jsx(Col, { flex: "1 1 auto", children: /* @__PURE__ */ jsx(
            "div",
            {
              ref: tagsRef,
              className: classnames([
                "perxis-auto-dealers-list-item__tags",
                {
                  "perxis-auto-dealers-list-item__tags--overflow": tagsOverflow
                }
              ]),
              children: tags.map((tag) => /* @__PURE__ */ jsx(
                DealerDetails,
                {
                  tooltipTitle: tag.description,
                  icon: !!tag.icon && /* @__PURE__ */ jsx(Icon, { name: tag.icon, sticker: "dealers-list-item-tag-icon" }),
                  iconPosition: tag.iconPosition,
                  iconColor: tag.iconColor,
                  iconHoverColor: tag.iconHoverColor,
                  color: tag.color,
                  borderColor: tag.borderColor,
                  borderHoverColor: tag.borderHoverColor,
                  backgroundColor: tag.backgroundColor,
                  children: tag.name,
                  className: classnames("perxis-auto-dealers-list-item-tag")
                },
                tag.id
              ))
            }
          ) }),
          /* @__PURE__ */ jsx(Col, { flex: "none", className: classnames("perxis-auto-dealers-list-item__forward-wrapper"), children: directionalIcon })
        ] }) })
      ] })
    }
  );
};
const DealersListItem$1 = React.memo(DealersListItem);
export {
  DealersListItem$1 as default
};
//# sourceMappingURL=DealersListItem.js.map
